export function isWithinFileSizeLimit(
  fileSizeInBytes: number | undefined,
  maxFileSizeInMB: number,
): boolean {
  const adjustedFileSize = fileSizeInBytes || 0;
  const fileSizeInMB = adjustedFileSize / 1024 / 1024;

  if (fileSizeInMB < maxFileSizeInMB) {
    return true;
  } else {
    return false;
  }
}
